import { motion } from "framer-motion";
import { useLang } from "@/i18n";

const PHOTOS = [
  { src: "/images/retrouvailles/table.jpg", alt: "Table généreuse de plats camerounais", wide: true },
  { src: "/images/retrouvailles/plats.jpg", alt: "Plats des Retrouvailles", wide: false },
  { src: "/images/retrouvailles/grillades.jpg", alt: "Grillades à la braise", wide: false },
  { src: "/images/retrouvailles/soupe.jpg", alt: "Soupe maison", wide: false },
  { src: "/images/retrouvailles/boissons.jpg", alt: "Boissons bien fraîches", wide: false },
  { src: "/images/retrouvailles/gathering.jpg", alt: "Retrouvailles entre amis", wide: true },
];

const Gallery = () => {
  const { t } = useLang();

  return (
    <section id="galerie" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-32" data-testid="gallery-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-12"
      >
        <p className="mb-3 font-mono2 text-xs uppercase tracking-[0.3em] text-[#A9761F]">{t.gallery.overline}</p>
        <h2 className="font-display text-3xl font-semibold tracking-tight text-[#C25E18] sm:text-4xl lg:text-5xl" data-testid="gallery-title">
          {t.gallery.title}
        </h2>
      </motion.div>

      <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
        {PHOTOS.map((p, i) => (
          <motion.figure
            key={p.src}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
            className={`group relative overflow-hidden rounded-xl border border-[#EBDDC6] ${p.wide ? "col-span-2 aspect-[2/1]" : "aspect-square"}`}
            data-testid={`gallery-photo-${i}`}
          >
            <img src={p.src} alt={p.alt} loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#FDF6EC]/70 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            <figcaption className="absolute bottom-3 left-3 translate-y-2 text-sm text-[#3B2A1E] opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
              {p.alt}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
